<template>
  <form
    class="new-user box is-centered"
    @submit.prevent="onSubmit"
  >
    <h1 class="title is-4 has-text-primary">
      Registro de Empresa
    </h1>

    <div class="columns is-multiline">
      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputField
          id="name"
          name="name"
          label="Nombre"
          left-icon="person"
          placeholder="Some Else"
          :value="name"
          :disabled="isLoading"
          required
          @input="onChangeName"
          @change="onChangeName"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputField
          id="companyName"
          name="name"
          label="Razón social:"
          left-icon="label"
          placeholder="Machete SA de CV"
          :value="companyName"
          :disabled="isLoading"
          required
          @input="onChangeCompany"
          @change="onChangeCompany"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputField
          id="tradeName"
          name="tradeName"
          label="Nombre Comercial:"
          left-icon="label"
          placeholder="Machete"
          :value="tradeName"
          :disabled="isLoading"
          required
          @input="onChangeCompany"
          @change="onChangeCompany"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputRfc
          :value="rfc"
          :disabled="isLoading"
          :valid-icon="false"
          @input="onChangeRfc"
          @change="onChangeRfc"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputEmail
          :value="email"
          :disabled="isLoading"
          required
          @input="onChange"
          @change="onChange"
        />
      </div>

      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppSelectField
          id="role"
          name="role"
          label="Rol"
          placeholder="Selecciona una opción"
          :value="role"
          :disabled="isLoading"
          :options="filteredOptions"
          required
          @input="onChange"
          @change="onChange"
        />
      </div>
      <div class="column is-12-mobile is-12-fullhd is-6">
        <AppInputPhoneNumber
          :value="phoneNumber"
          :disabled="isLoading"
          :valid-icon="false"
          @input="onChange"
          @change="onChange"
        />
      </div>
      <div class="column is-12">
        <div class="field is-centered">
          <input
            id="sendEmail"
            class="is-checkradio"
            :class="{ 'is-success': sendEmail }"
            type="checkbox"
            name="sendEmail"
            :checked="sendEmail"
            @change="onChangeSendEmail"
          >
          <label for="sendEmail">
            Enviar Email de Registro
          </label>
        </div>
      </div>
    </div>

    <ButtonSubmit
      :is-loading="isLoading"
      text="guardar usuario"
    />
  </form>
</template>

<script>
import capitalize from 'lodash/capitalize';
import upperFirst from 'lodash/upperFirst';
import { mapState, mapMutations, mapActions } from 'vuex';

import AppInputField from '@/components/AppInputField.vue';
import AppSelectField from '@/components/AppSelectField.vue';
import AppInputPhoneNumber from '@/components/AppInputPhoneNumber.vue';

export default {
  name: 'NewUser',
  components: {
    AppInputField,
    AppSelectField,
    AppInputPhoneNumber,
    AppInputEmail: () => import(/* webpackChunkName: "app-input-email" */ '@/components/AppInputEmail.vue'),
    AppInputRfc: () => import(/* webpackChunkName: "app-input-rfc" */ '@/components/AppInputRfc.vue'),
    ButtonSubmit: () => import(/* webpackChunkName: "auth-button-submit" */ '@/components/Auth/ButtonSubmit.vue'),
  },
  data() {
    return {
      isLoading: false,
      roleOptions: [
        { value: 'admin', label: 'Administrador', level: 9 },
        { value: 'totalplay', label: 'Totalplay', level: 8 },
        { value: 'customer', label: 'Cliente', level: 7 },
      ],
    };
  },
  computed: {
    ...mapState({
      tradeName: state => state.users.company.tradeName,
      companyName: state => state.users.company.name,
      sendEmail: state => state.users.sendEmail,
      rfc: state => state.users.company.rfc,
      signedRole: state => state.auth.role,
      email: state => state.users.email,
      name: state => state.users.name,
      role: state => state.users.role,
      phoneNumber: state => state.users.phoneNumber,
    }),
    filteredOptions() {
      const { level } = this.roleOptions.find(role => role.value === this.signedRole);
      const options = this.roleOptions.filter(role => role.level <= level);

      return options;
    },
  },
  methods: {
    ...mapMutations({
      setUserValue: 'users/setValue',
      setCompanyValue: 'users/setCompanyValue',
    }),
    ...mapActions({
      newUser: 'users/create',
    }),
    onChangeName(event) {
      const { name: accessor, value: plainValue } = event.target;

      const value = plainValue.split(' ').map(capitalize).join(' ');

      this.setUserValue({ accessor, value });
    },
    onChangeCompany(event) {
      const { name: accessor, value: plainValue } = event.target;

      const value = plainValue.split(' ').map(upperFirst).join(' ');

      this.setCompanyValue({ accessor, value });
    },
    onChangeEmail(event) {
      const { name: accessor, value } = event.target;

      this.setUserValue({ accessor, value });
    },
    onChangeRfc(event) {
      const { name: accessor, value } = event.target;

      this.setCompanyValue({ accessor, value });
    },
    onChange(event) {
      const { name: accessor, value } = event.target;
      this.setUserValue({ accessor, value });
    },
    onChangeSendEmail(event) {
      const { name: accessor, checked: value } = event.target;
      this.setUserValue({ accessor, value });
    },
    onChangePhoneNumber(event) {
      const { name: accessor, checked: value } = event.target;
      this.setPhoneNumberValue({ accessor, value });
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        await this.newUser();
        this.$router.replace({ name: 'UsersList' });
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: error.message,
        });
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
form {
  flex-direction: column;
  margin: auto;
}

.submit-button {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.is-checkradio[type="checkbox"] + label::after,
.is-checkradio[type="checkbox"] + label:after {
  width: 0.4rem;
  height: .95rem;
  top: 0.405rem;
  left: 0.6rem;
}

.is-checkradio[type="radio"] + label::before,
.is-checkradio[type="radio"] + label:before,
.is-checkradio[type="checkbox"] + label::before,
.is-checkradio[type="checkbox"] + label:before {
  top: unset;
}

@media screen and (min-width: 769px) {
  form {
    max-width: 750px;
  }
}
</style>

<style lang="scss">
.new-user {
  .button.is-text,
  .button.is-text:hover,
  .button.is-text:focus {
    background: none;
    color: $primary;
  }
}
</style>
